export const DEALER_SETTINGS_VISIBILITY_URL = "/DealerSettings/visibility";
export const DEALER_SETTINGS_QUANTITY_URL = "/DealerSettings/quantity";
export const DEALER_SETTINGS_MARKUPS_URL = "/DealerSettings/markups";
export const DEALER_SETTINGS_MARKUPS_LIST_URL = "/DealerSettings/markups/list";
export const DEALER_SETTINGS_CLEAN_URL = "/DealerSettings/clean";
